import React from "react";
import Button from "@components/common/Button/Button";
import { useTranslation } from "react-i18next";

interface ActionButtonsProps {
	isEdit: boolean;
	isView?: boolean;
	isFormValid: boolean;
	isSubmitting: boolean;
	onCancel: () => void;
	onSubmit: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
	isEdit,
	isView = false,
	isFormValid,
	isSubmitting,
	onCancel,
	onSubmit,
}) => {
	const { t } = useTranslation();

	if (isView) {
		return (
			<div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
				<Button variant="primary" onClick={onCancel}>
					{t("psdaCommon.common.buttons.close")}
				</Button>
			</div>
		);
	}

	return (
		<div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
			<Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
				{t("psdaCommon.common.buttons.cancel")}
			</Button>
			<Button variant="primary" onClick={onSubmit} disabled={!isFormValid || isSubmitting} loading={isSubmitting}>
				{isEdit ? t("feature.courseBuilder.labs.buttons.editLab") : t("feature.courseBuilder.labs.buttons.addLab")}
			</Button>
		</div>
	);
};

export default ActionButtons;
